import { getRequestData } from '@/utils';
import { qryFrBpayInfo } from '@/pages/BillDesk/services/billDesk';
import get from "lodash/get";

export default {
  namespace: 'billDesk',
  state: {
    frBpayInfo: {},
    bankAcctInfo: {},
    attachInfoList: [],
  },
  effects: {
    *qryFrBpayInfo({ payload }, { call, put }) {
      const response = yield call(qryFrBpayInfo, payload);
      const { frBpayInfo = {} } = getRequestData(response);
      const bankAcctInfo = get(frBpayInfo, 'bankAcctInfo') || {};
      const attachInfoList = get(bankAcctInfo, 'attachInfoList') || [];
      yield put({
        type: 'save',
        payload: {
          frBpayInfo: frBpayInfo || {},
          bankAcctInfo: bankAcctInfo || {},
          attachInfoList: attachInfoList || [],
        },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
